import type { User } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

export const GET_CARER_BASE = `/api/list/carers`

const useCarer = (carerId?: string) => {
  const { isLoading, data, refetch } = useQuery(
    ['carers', carerId],
    () =>
      getJSON({
        url: `${GET_CARER_BASE}/${carerId}`
      }),
    { enabled: !!carerId }
  )

  return {
    isLoading,
    carer: data?.result as User,
    refetch
  }
}

export default useCarer
